// extracted by mini-css-extract-plugin
export var backupIcon = "_no-1";
export var image = "_no-0";